import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image"
export default class extends Controller {
    connect() {
        this.element.addEventListener("load", this.#handleLoad)
    }

    disconnect() {
        this.element.removeEventListener("load", this.#handleLoad)
    }

    #handleLoad = () => { this.element.classList.remove("skeleton") }
}
